'use strict';
export const validateRegistrationRequestTokenBody = validate11;
const schema12 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        TopLevel: {
            type: 'object',
            additionalProperties: false,
            properties: {
                display_name: {
                    type: 'string',
                    description: 'The name by which this participant should be known.',
                },
                call_tag: {
                    type: 'string',
                    description: 'An optional call tag to assign to this participant.',
                },
                chosen_idp: { type: 'string' },
                client_id: { type: 'string' },
                sso_token: { type: 'string' },
                sso_redirect_target: {
                    type: 'string',
                    description: "Specifically, the template must contain a magic placeholder __pexip-sso-token__ which will be replaced with the real resumption token once SSO has completed. So, for example https://nightly.pexip.com/path/to/wherever/the/client/wants/__pexip-sso-token__ (the client could also request the token be injected as a query parameter -- the backend doesn't care, or make any assumptions about the URI structure used by the client software)",
                },
                node: {
                    type: 'string',
                    description: '`<FQDN/address that the client is connecting to>`. This helps with some SAML SSO flows.',
                },
                conference_extension: {
                    type: 'string',
                    description: 'Alias of the target conference',
                },
                token: {
                    type: 'string',
                    description: 'One time token for joining a call',
                },
                direct_media: { type: 'boolean' },
                breakout_rooms: { type: 'boolean' },
                supports_direct_chat: {
                    type: 'boolean',
                    description: 'Boolean indicating whether the participant can receive and send a direct chat message..',
                },
            },
            required: [],
            title: 'TopLevel',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/registration_request_token/properties/Body/definitions/TopLevel',
        },
    ],
};
const schema13 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        display_name: {
            type: 'string',
            description: 'The name by which this participant should be known.',
        },
        call_tag: {
            type: 'string',
            description: 'An optional call tag to assign to this participant.',
        },
        chosen_idp: { type: 'string' },
        client_id: { type: 'string' },
        sso_token: { type: 'string' },
        sso_redirect_target: {
            type: 'string',
            description: "Specifically, the template must contain a magic placeholder __pexip-sso-token__ which will be replaced with the real resumption token once SSO has completed. So, for example https://nightly.pexip.com/path/to/wherever/the/client/wants/__pexip-sso-token__ (the client could also request the token be injected as a query parameter -- the backend doesn't care, or make any assumptions about the URI structure used by the client software)",
        },
        node: {
            type: 'string',
            description: '`<FQDN/address that the client is connecting to>`. This helps with some SAML SSO flows.',
        },
        conference_extension: {
            type: 'string',
            description: 'Alias of the target conference',
        },
        token: {
            type: 'string',
            description: 'One time token for joining a call',
        },
        direct_media: { type: 'boolean' },
        breakout_rooms: { type: 'boolean' },
        supports_direct_chat: {
            type: 'boolean',
            description: 'Boolean indicating whether the participant can receive and send a direct chat message..',
        },
    },
    required: [],
    title: 'TopLevel',
};
const func2 = Object.prototype.hasOwnProperty;
function validate11(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            const _errs4 = errors;
            for (const key0 in data) {
                if (!func2.call(schema13.properties, key0)) {
                    delete data[key0];
                }
            }
            if (_errs4 === errors) {
                if (data.display_name !== undefined) {
                    const _errs5 = errors;
                    if (typeof data.display_name !== 'string') {
                        const err0 = {
                            instancePath: instancePath + '/display_name',
                            schemaPath: '#/definitions/registration_request_token/properties/Body/definitions/TopLevel/properties/display_name/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                        };
                        if (vErrors === null) {
                            vErrors = [err0];
                        }
                        else {
                            vErrors.push(err0);
                        }
                        errors++;
                    }
                    var valid2 = _errs5 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.call_tag !== undefined) {
                        const _errs7 = errors;
                        if (typeof data.call_tag !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/call_tag',
                                schemaPath: '#/definitions/registration_request_token/properties/Body/definitions/TopLevel/properties/call_tag/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            }
                            else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        var valid2 = _errs7 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.chosen_idp !== undefined) {
                            const _errs9 = errors;
                            if (typeof data.chosen_idp !== 'string') {
                                const err2 = {
                                    instancePath: instancePath + '/chosen_idp',
                                    schemaPath: '#/definitions/registration_request_token/properties/Body/definitions/TopLevel/properties/chosen_idp/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                };
                                if (vErrors === null) {
                                    vErrors = [err2];
                                }
                                else {
                                    vErrors.push(err2);
                                }
                                errors++;
                            }
                            var valid2 = _errs9 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.client_id !== undefined) {
                                const _errs11 = errors;
                                if (typeof data.client_id !== 'string') {
                                    const err3 = {
                                        instancePath: instancePath + '/client_id',
                                        schemaPath: '#/definitions/registration_request_token/properties/Body/definitions/TopLevel/properties/client_id/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err3];
                                    }
                                    else {
                                        vErrors.push(err3);
                                    }
                                    errors++;
                                }
                                var valid2 = _errs11 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.sso_token !== undefined) {
                                    const _errs13 = errors;
                                    if (typeof data.sso_token !== 'string') {
                                        const err4 = {
                                            instancePath: instancePath + '/sso_token',
                                            schemaPath: '#/definitions/registration_request_token/properties/Body/definitions/TopLevel/properties/sso_token/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err4];
                                        }
                                        else {
                                            vErrors.push(err4);
                                        }
                                        errors++;
                                    }
                                    var valid2 = _errs13 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data.sso_redirect_target !== undefined) {
                                        const _errs15 = errors;
                                        if (typeof data.sso_redirect_target !==
                                            'string') {
                                            const err5 = {
                                                instancePath: instancePath +
                                                    '/sso_redirect_target',
                                                schemaPath: '#/definitions/registration_request_token/properties/Body/definitions/TopLevel/properties/sso_redirect_target/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err5];
                                            }
                                            else {
                                                vErrors.push(err5);
                                            }
                                            errors++;
                                        }
                                        var valid2 = _errs15 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data.node !== undefined) {
                                            const _errs17 = errors;
                                            if (typeof data.node !== 'string') {
                                                const err6 = {
                                                    instancePath: instancePath + '/node',
                                                    schemaPath: '#/definitions/registration_request_token/properties/Body/definitions/TopLevel/properties/node/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err6];
                                                }
                                                else {
                                                    vErrors.push(err6);
                                                }
                                                errors++;
                                            }
                                            var valid2 = _errs17 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data.conference_extension !==
                                                undefined) {
                                                const _errs19 = errors;
                                                if (typeof data.conference_extension !==
                                                    'string') {
                                                    const err7 = {
                                                        instancePath: instancePath +
                                                            '/conference_extension',
                                                        schemaPath: '#/definitions/registration_request_token/properties/Body/definitions/TopLevel/properties/conference_extension/type',
                                                        keyword: 'type',
                                                        params: {
                                                            type: 'string',
                                                        },
                                                        message: 'must be string',
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err7];
                                                    }
                                                    else {
                                                        vErrors.push(err7);
                                                    }
                                                    errors++;
                                                }
                                                var valid2 = _errs19 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data.token !== undefined) {
                                                    const _errs21 = errors;
                                                    if (typeof data.token !==
                                                        'string') {
                                                        const err8 = {
                                                            instancePath: instancePath +
                                                                '/token',
                                                            schemaPath: '#/definitions/registration_request_token/properties/Body/definitions/TopLevel/properties/token/type',
                                                            keyword: 'type',
                                                            params: {
                                                                type: 'string',
                                                            },
                                                            message: 'must be string',
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err8];
                                                        }
                                                        else {
                                                            vErrors.push(err8);
                                                        }
                                                        errors++;
                                                    }
                                                    var valid2 = _errs21 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                                if (valid2) {
                                                    if (data.direct_media !==
                                                        undefined) {
                                                        const _errs23 = errors;
                                                        if (typeof data.direct_media !==
                                                            'boolean') {
                                                            const err9 = {
                                                                instancePath: instancePath +
                                                                    '/direct_media',
                                                                schemaPath: '#/definitions/registration_request_token/properties/Body/definitions/TopLevel/properties/direct_media/type',
                                                                keyword: 'type',
                                                                params: {
                                                                    type: 'boolean',
                                                                },
                                                                message: 'must be boolean',
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [
                                                                    err9,
                                                                ];
                                                            }
                                                            else {
                                                                vErrors.push(err9);
                                                            }
                                                            errors++;
                                                        }
                                                        var valid2 = _errs23 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                        if (data.breakout_rooms !==
                                                            undefined) {
                                                            const _errs25 = errors;
                                                            if (typeof data.breakout_rooms !==
                                                                'boolean') {
                                                                const err10 = {
                                                                    instancePath: instancePath +
                                                                        '/breakout_rooms',
                                                                    schemaPath: '#/definitions/registration_request_token/properties/Body/definitions/TopLevel/properties/breakout_rooms/type',
                                                                    keyword: 'type',
                                                                    params: {
                                                                        type: 'boolean',
                                                                    },
                                                                    message: 'must be boolean',
                                                                };
                                                                if (vErrors ===
                                                                    null) {
                                                                    vErrors = [
                                                                        err10,
                                                                    ];
                                                                }
                                                                else {
                                                                    vErrors.push(err10);
                                                                }
                                                                errors++;
                                                            }
                                                            var valid2 = _errs25 ===
                                                                errors;
                                                        }
                                                        else {
                                                            var valid2 = true;
                                                        }
                                                        if (valid2) {
                                                            if (data.supports_direct_chat !==
                                                                undefined) {
                                                                const _errs27 = errors;
                                                                if (typeof data.supports_direct_chat !==
                                                                    'boolean') {
                                                                    const err11 = {
                                                                        instancePath: instancePath +
                                                                            '/supports_direct_chat',
                                                                        schemaPath: '#/definitions/registration_request_token/properties/Body/definitions/TopLevel/properties/supports_direct_chat/type',
                                                                        keyword: 'type',
                                                                        params: {
                                                                            type: 'boolean',
                                                                        },
                                                                        message: 'must be boolean',
                                                                    };
                                                                    if (vErrors ===
                                                                        null) {
                                                                        vErrors =
                                                                            [
                                                                                err11,
                                                                            ];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err11);
                                                                    }
                                                                    errors++;
                                                                }
                                                                var valid2 = _errs27 ===
                                                                    errors;
                                                            }
                                                            else {
                                                                var valid2 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            const err12 = {
                instancePath,
                schemaPath: '#/definitions/registration_request_token/properties/Body/definitions/TopLevel/type',
                keyword: 'type',
                params: { type: 'object' },
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err12];
            }
            else {
                vErrors.push(err12);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err13 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err13];
        }
        else {
            vErrors.push(err13);
        }
        errors++;
        validate11.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate11.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationRequestToken200 = validate12;
const schema14 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '200': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. success.',
                    enum: ['success'],
                },
                result: {
                    $ref: '#/definitions/registration_request_token/properties/200/definitions/Result',
                },
            },
            required: ['status', 'result'],
            title: 'Status200',
        },
        Result: {
            type: 'object',
            description: 'This result contains the token (abridged in the above example) to use to authenticate all future requests, and an expiry time (in seconds) after which this token becomes invalid.',
            additionalProperties: false,
            properties: {
                token: {
                    type: 'string',
                    description: 'The authentication token for future requests.',
                },
                expires: {
                    type: 'string',
                    description: 'Validity lifetime in seconds. Use refresh_token to obtain an updated token.',
                },
                auth_token: { type: 'string' },
                registration_uuid: {
                    type: 'string',
                    description: 'The uuid associated with this newly created registration. It is used to identify this registration',
                },
                version: {
                    $ref: '#/definitions/registration_request_token/properties/200/definitions/Version',
                },
                directory_enabled: { type: 'boolean' },
                route_via_registrar: { type: 'boolean' },
                display_name: { type: 'string' },
            },
            required: [
                'token',
                'expires',
                'registration_uuid',
                'version',
                'directory_enabled',
                'route_via_registrar',
            ],
            title: 'Result',
        },
        Version: {
            type: 'object',
            description: 'This result contains the token (abridged in the above example) to use to authenticate all future requests, and an expiry time (in seconds) after which this token becomes invalid.',
            additionalProperties: false,
            properties: {
                version_id: { type: 'string' },
                pseudo_version: { type: 'string' },
            },
            required: [],
            title: 'Version',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/registration_request_token/properties/200/definitions/200',
        },
    ],
};
const schema15 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. success.',
            enum: ['success'],
        },
        result: {
            $ref: '#/definitions/registration_request_token/properties/200/definitions/Result',
        },
    },
    required: ['status', 'result'],
    title: 'Status200',
};
const schema16 = {
    type: 'object',
    description: 'This result contains the token (abridged in the above example) to use to authenticate all future requests, and an expiry time (in seconds) after which this token becomes invalid.',
    additionalProperties: false,
    properties: {
        token: {
            type: 'string',
            description: 'The authentication token for future requests.',
        },
        expires: {
            type: 'string',
            description: 'Validity lifetime in seconds. Use refresh_token to obtain an updated token.',
        },
        auth_token: { type: 'string' },
        registration_uuid: {
            type: 'string',
            description: 'The uuid associated with this newly created registration. It is used to identify this registration',
        },
        version: {
            $ref: '#/definitions/registration_request_token/properties/200/definitions/Version',
        },
        directory_enabled: { type: 'boolean' },
        route_via_registrar: { type: 'boolean' },
        display_name: { type: 'string' },
    },
    required: [
        'token',
        'expires',
        'registration_uuid',
        'version',
        'directory_enabled',
        'route_via_registrar',
    ],
    title: 'Result',
};
const schema17 = {
    type: 'object',
    description: 'This result contains the token (abridged in the above example) to use to authenticate all future requests, and an expiry time (in seconds) after which this token becomes invalid.',
    additionalProperties: false,
    properties: {
        version_id: { type: 'string' },
        pseudo_version: { type: 'string' },
    },
    required: [],
    title: 'Version',
};
function validate14(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.token === undefined && (missing0 = 'token')) ||
                (data.expires === undefined && (missing0 = 'expires')) ||
                (data.registration_uuid === undefined &&
                    (missing0 = 'registration_uuid')) ||
                (data.version === undefined && (missing0 = 'version')) ||
                (data.directory_enabled === undefined &&
                    (missing0 = 'directory_enabled')) ||
                (data.route_via_registrar === undefined &&
                    (missing0 = 'route_via_registrar'))) {
                validate14.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            }
            else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'token' ||
                        key0 === 'expires' ||
                        key0 === 'auth_token' ||
                        key0 === 'registration_uuid' ||
                        key0 === 'version' ||
                        key0 === 'directory_enabled' ||
                        key0 === 'route_via_registrar' ||
                        key0 === 'display_name')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.token !== undefined) {
                        const _errs2 = errors;
                        if (typeof data.token !== 'string') {
                            validate14.errors = [
                                {
                                    instancePath: instancePath + '/token',
                                    schemaPath: '#/properties/token/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.expires !== undefined) {
                            const _errs4 = errors;
                            if (typeof data.expires !== 'string') {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/expires',
                                        schemaPath: '#/properties/expires/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                    },
                                ];
                                return false;
                            }
                            var valid0 = _errs4 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.auth_token !== undefined) {
                                const _errs6 = errors;
                                if (typeof data.auth_token !== 'string') {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/auth_token',
                                            schemaPath: '#/properties/auth_token/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                        },
                                    ];
                                    return false;
                                }
                                var valid0 = _errs6 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.registration_uuid !== undefined) {
                                    const _errs8 = errors;
                                    if (typeof data.registration_uuid !==
                                        'string') {
                                        validate14.errors = [
                                            {
                                                instancePath: instancePath +
                                                    '/registration_uuid',
                                                schemaPath: '#/properties/registration_uuid/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                            },
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs8 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.version !== undefined) {
                                        let data4 = data.version;
                                        const _errs10 = errors;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (data4 &&
                                                typeof data4 == 'object' &&
                                                !Array.isArray(data4)) {
                                                const _errs13 = errors;
                                                for (const key1 in data4) {
                                                    if (!(key1 === 'version_id' ||
                                                        key1 ===
                                                            'pseudo_version')) {
                                                        delete data4[key1];
                                                    }
                                                }
                                                if (_errs13 === errors) {
                                                    if (data4.version_id !==
                                                        undefined) {
                                                        const _errs14 = errors;
                                                        if (typeof data4.version_id !==
                                                            'string') {
                                                            validate14.errors =
                                                                [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/version/version_id',
                                                                        schemaPath: '#/definitions/registration_request_token/properties/200/definitions/Version/properties/version_id/type',
                                                                        keyword: 'type',
                                                                        params: {
                                                                            type: 'string',
                                                                        },
                                                                        message: 'must be string',
                                                                    },
                                                                ];
                                                            return false;
                                                        }
                                                        var valid2 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                        if (data4.pseudo_version !==
                                                            undefined) {
                                                            const _errs16 = errors;
                                                            if (typeof data4.pseudo_version !==
                                                                'string') {
                                                                validate14.errors =
                                                                    [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/version/pseudo_version',
                                                                            schemaPath: '#/definitions/registration_request_token/properties/200/definitions/Version/properties/pseudo_version/type',
                                                                            keyword: 'type',
                                                                            params: {
                                                                                type: 'string',
                                                                            },
                                                                            message: 'must be string',
                                                                        },
                                                                    ];
                                                                return false;
                                                            }
                                                            var valid2 = _errs16 ===
                                                                errors;
                                                        }
                                                        else {
                                                            var valid2 = true;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate14.errors = [
                                                    {
                                                        instancePath: instancePath +
                                                            '/version',
                                                        schemaPath: '#/definitions/registration_request_token/properties/200/definitions/Version/type',
                                                        keyword: 'type',
                                                        params: {
                                                            type: 'object',
                                                        },
                                                        message: 'must be object',
                                                    },
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs10 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.directory_enabled !== undefined) {
                                            const _errs18 = errors;
                                            if (typeof data.directory_enabled !==
                                                'boolean') {
                                                validate14.errors = [
                                                    {
                                                        instancePath: instancePath +
                                                            '/directory_enabled',
                                                        schemaPath: '#/properties/directory_enabled/type',
                                                        keyword: 'type',
                                                        params: {
                                                            type: 'boolean',
                                                        },
                                                        message: 'must be boolean',
                                                    },
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs18 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.route_via_registrar !==
                                                undefined) {
                                                const _errs20 = errors;
                                                if (typeof data.route_via_registrar !==
                                                    'boolean') {
                                                    validate14.errors = [
                                                        {
                                                            instancePath: instancePath +
                                                                '/route_via_registrar',
                                                            schemaPath: '#/properties/route_via_registrar/type',
                                                            keyword: 'type',
                                                            params: {
                                                                type: 'boolean',
                                                            },
                                                            message: 'must be boolean',
                                                        },
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs20 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.display_name !==
                                                    undefined) {
                                                    const _errs22 = errors;
                                                    if (typeof data.display_name !==
                                                        'string') {
                                                        validate14.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/display_name',
                                                                schemaPath: '#/properties/display_name/type',
                                                                keyword: 'type',
                                                                params: {
                                                                    type: 'string',
                                                                },
                                                                message: 'must be string',
                                                            },
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs22 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate14.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate14.errors = vErrors;
    return errors === 0;
}
function validate13(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))) {
                validate13.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            }
            else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs2 = errors;
                        if (typeof data0 !== 'string') {
                            validate13.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        if (!(data0 === 'success')) {
                            validate13.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/enum',
                                    keyword: 'enum',
                                    params: {
                                        allowedValues: schema15.properties.status.enum,
                                    },
                                    message: 'must be equal to one of the allowed values',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.result !== undefined) {
                            const _errs4 = errors;
                            if (!validate14(data.result, {
                                instancePath: instancePath + '/result',
                                parentData: data,
                                parentDataProperty: 'result',
                                rootData,
                            })) {
                                vErrors =
                                    vErrors === null
                                        ? validate14.errors
                                        : vErrors.concat(validate14.errors);
                                errors = vErrors.length;
                            }
                            var valid0 = _errs4 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate13.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate13.errors = vErrors;
    return errors === 0;
}
function validate12(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (!validate13(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
    })) {
        vErrors =
            vErrors === null
                ? validate13.errors
                : vErrors.concat(validate13.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
        validate12.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate12.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationRequestToken401 = validate17;
const schema18 = { type: 'string' };
function validate17(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (typeof data !== 'string') {
        validate17.errors = [
            {
                instancePath,
                schemaPath: '#/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
            },
        ];
        return false;
    }
    validate17.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationRequestToken403 = validate18;
const schema19 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '403': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. success.',
                    enum: ['success', 'failed', 'error'],
                },
                result: {
                    oneOf: [
                        {
                            $ref: '#/definitions/registration_request_token/properties/403/definitions/Result',
                        },
                        {
                            $ref: '#/definitions/registration_request_token/properties/403/definitions/ResultIdp',
                        },
                        {
                            $ref: '#/definitions/registration_request_token/properties/403/definitions/ResultRedirect',
                        },
                        {
                            $ref: '#/definitions/registration_request_token/properties/415/definitions/415/properties/result',
                        },
                    ],
                },
            },
            required: ['status', 'result'],
            title: 'Status403',
        },
        Result: {
            type: 'object',
            description: 'If the conference is PIN-protected, the PIN must be specified in a `pin` HTTP header. If the PIN is required but is incorrect or missing, a `403 Forbidden` error is returned.',
            additionalProperties: false,
            properties: {
                conference_extension: {
                    type: 'string',
                    enum: ['standard', 'mssip'],
                },
                guest_pin: {
                    type: 'string',
                    description: 'Guest pin',
                    enum: ['required', 'none'],
                },
                pin: {
                    type: 'string',
                    description: 'Host pin',
                    enum: ['required', 'none'],
                },
                version: {
                    $ref: '#/definitions/registration_request_token/properties/403/definitions/Version',
                },
            },
            required: ['version', 'guest_pin', 'pin'],
            title: 'Result',
        },
        ResultIdp: {
            type: 'object',
            description: 'If the conference is PIN-protected, the PIN must be specified in a `pin` HTTP header. If the PIN is required but is incorrect or missing, a `403 Forbidden` error is returned.',
            additionalProperties: false,
            properties: {
                idp: {
                    type: 'array',
                    description: 'Idp providers',
                    items: {
                        $ref: '#/definitions/registration_request_token/properties/403/definitions/Idp',
                    },
                },
                version: {
                    $ref: '#/definitions/registration_request_token/properties/403/definitions/Version',
                },
            },
            required: ['idp', 'version'],
            title: 'Result',
        },
        ResultRedirect: {
            type: 'object',
            description: 'If the conference is PIN-protected, the PIN must be specified in a `pin` HTTP header. If the PIN is required but is incorrect or missing, a `403 Forbidden` error is returned.',
            additionalProperties: false,
            properties: {
                redirect_url: {
                    type: 'string',
                    description: "`<IdP's SSO URL>?SAMLRequest=<Base64 encoded SAML AuthNRequest message>`",
                },
                redirect_idp: {
                    $ref: '#/definitions/registration_request_token/properties/403/definitions/RedirectIdp',
                },
                version: {
                    $ref: '#/definitions/registration_request_token/properties/403/definitions/Version',
                },
                disable_popup_flow: {
                    type: 'boolean',
                    description: 'If true, the IDP supports a direct redirect flow without popup. The sso_redirect_target is validated at this point.',
                },
            },
            required: ['redirect_url', 'redirect_idp', 'version'],
            title: 'ResultRedirect',
        },
        Idp: {
            type: 'object',
            additionalProperties: false,
            properties: {
                name: { type: 'string' },
                img: { type: 'string' },
                uuid: { type: 'string' },
                disable_popup_flow: {
                    type: 'boolean',
                    description: 'If true, the IDP supports a direct redirect flow without popup. The sso_redirect_target is not validated at this point.',
                },
            },
            required: ['name', 'uuid'],
            title: 'Idp',
        },
        RedirectIdp: {
            type: 'object',
            additionalProperties: false,
            properties: { name: { type: 'string' }, uuid: { type: 'string' } },
            required: ['name', 'uuid'],
            title: 'RedirectIdp',
        },
        Version: {
            type: 'object',
            description: 'This result contains the token (abridged in the above example) to use to authenticate all future requests, and an expiry time (in seconds) after which this token becomes invalid.',
            additionalProperties: false,
            properties: {
                version_id: { type: 'string' },
                pseudo_version: { type: 'string' },
            },
            required: [],
            title: 'Version',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/registration_request_token/properties/403/definitions/403',
        },
    ],
};
const schema20 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. success.',
            enum: ['success', 'failed', 'error'],
        },
        result: {
            oneOf: [
                {
                    $ref: '#/definitions/registration_request_token/properties/403/definitions/Result',
                },
                {
                    $ref: '#/definitions/registration_request_token/properties/403/definitions/ResultIdp',
                },
                {
                    $ref: '#/definitions/registration_request_token/properties/403/definitions/ResultRedirect',
                },
                {
                    $ref: '#/definitions/registration_request_token/properties/415/definitions/415/properties/result',
                },
            ],
        },
    },
    required: ['status', 'result'],
    title: 'Status403',
};
const schema29 = { type: 'string', description: 'Error strings' };
const schema21 = {
    type: 'object',
    description: 'If the conference is PIN-protected, the PIN must be specified in a `pin` HTTP header. If the PIN is required but is incorrect or missing, a `403 Forbidden` error is returned.',
    additionalProperties: false,
    properties: {
        conference_extension: { type: 'string', enum: ['standard', 'mssip'] },
        guest_pin: {
            type: 'string',
            description: 'Guest pin',
            enum: ['required', 'none'],
        },
        pin: {
            type: 'string',
            description: 'Host pin',
            enum: ['required', 'none'],
        },
        version: {
            $ref: '#/definitions/registration_request_token/properties/403/definitions/Version',
        },
    },
    required: ['version', 'guest_pin', 'pin'],
    title: 'Result',
};
const schema22 = {
    type: 'object',
    description: 'This result contains the token (abridged in the above example) to use to authenticate all future requests, and an expiry time (in seconds) after which this token becomes invalid.',
    additionalProperties: false,
    properties: {
        version_id: { type: 'string' },
        pseudo_version: { type: 'string' },
    },
    required: [],
    title: 'Version',
};
function validate20(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.version === undefined && (missing0 = 'version')) ||
                (data.guest_pin === undefined && (missing0 = 'guest_pin')) ||
                (data.pin === undefined && (missing0 = 'pin'))) {
                validate20.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            }
            else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'conference_extension' ||
                        key0 === 'guest_pin' ||
                        key0 === 'pin' ||
                        key0 === 'version')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.conference_extension !== undefined) {
                        let data0 = data.conference_extension;
                        const _errs2 = errors;
                        if (typeof data0 !== 'string') {
                            validate20.errors = [
                                {
                                    instancePath: instancePath + '/conference_extension',
                                    schemaPath: '#/properties/conference_extension/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        if (!(data0 === 'standard' || data0 === 'mssip')) {
                            validate20.errors = [
                                {
                                    instancePath: instancePath + '/conference_extension',
                                    schemaPath: '#/properties/conference_extension/enum',
                                    keyword: 'enum',
                                    params: {
                                        allowedValues: schema21.properties
                                            .conference_extension.enum,
                                    },
                                    message: 'must be equal to one of the allowed values',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.guest_pin !== undefined) {
                            let data1 = data.guest_pin;
                            const _errs4 = errors;
                            if (typeof data1 !== 'string') {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/guest_pin',
                                        schemaPath: '#/properties/guest_pin/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                    },
                                ];
                                return false;
                            }
                            if (!(data1 === 'required' || data1 === 'none')) {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/guest_pin',
                                        schemaPath: '#/properties/guest_pin/enum',
                                        keyword: 'enum',
                                        params: {
                                            allowedValues: schema21.properties.guest_pin
                                                .enum,
                                        },
                                        message: 'must be equal to one of the allowed values',
                                    },
                                ];
                                return false;
                            }
                            var valid0 = _errs4 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.pin !== undefined) {
                                let data2 = data.pin;
                                const _errs6 = errors;
                                if (typeof data2 !== 'string') {
                                    validate20.errors = [
                                        {
                                            instancePath: instancePath + '/pin',
                                            schemaPath: '#/properties/pin/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                        },
                                    ];
                                    return false;
                                }
                                if (!(data2 === 'required' || data2 === 'none')) {
                                    validate20.errors = [
                                        {
                                            instancePath: instancePath + '/pin',
                                            schemaPath: '#/properties/pin/enum',
                                            keyword: 'enum',
                                            params: {
                                                allowedValues: schema21.properties.pin
                                                    .enum,
                                            },
                                            message: 'must be equal to one of the allowed values',
                                        },
                                    ];
                                    return false;
                                }
                                var valid0 = _errs6 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.version !== undefined) {
                                    let data3 = data.version;
                                    const _errs8 = errors;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (data3 &&
                                            typeof data3 == 'object' &&
                                            !Array.isArray(data3)) {
                                            const _errs11 = errors;
                                            for (const key1 in data3) {
                                                if (!(key1 === 'version_id' ||
                                                    key1 === 'pseudo_version')) {
                                                    delete data3[key1];
                                                }
                                            }
                                            if (_errs11 === errors) {
                                                if (data3.version_id !==
                                                    undefined) {
                                                    const _errs12 = errors;
                                                    if (typeof data3.version_id !==
                                                        'string') {
                                                        validate20.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/version/version_id',
                                                                schemaPath: '#/definitions/registration_request_token/properties/403/definitions/Version/properties/version_id/type',
                                                                keyword: 'type',
                                                                params: {
                                                                    type: 'string',
                                                                },
                                                                message: 'must be string',
                                                            },
                                                        ];
                                                        return false;
                                                    }
                                                    var valid2 = _errs12 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                                if (valid2) {
                                                    if (data3.pseudo_version !==
                                                        undefined) {
                                                        const _errs14 = errors;
                                                        if (typeof data3.pseudo_version !==
                                                            'string') {
                                                            validate20.errors =
                                                                [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/version/pseudo_version',
                                                                        schemaPath: '#/definitions/registration_request_token/properties/403/definitions/Version/properties/pseudo_version/type',
                                                                        keyword: 'type',
                                                                        params: {
                                                                            type: 'string',
                                                                        },
                                                                        message: 'must be string',
                                                                    },
                                                                ];
                                                            return false;
                                                        }
                                                        var valid2 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate20.errors = [
                                                {
                                                    instancePath: instancePath +
                                                        '/version',
                                                    schemaPath: '#/definitions/registration_request_token/properties/403/definitions/Version/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object',
                                                },
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs8 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate20.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate20.errors = vErrors;
    return errors === 0;
}
const schema23 = {
    type: 'object',
    description: 'If the conference is PIN-protected, the PIN must be specified in a `pin` HTTP header. If the PIN is required but is incorrect or missing, a `403 Forbidden` error is returned.',
    additionalProperties: false,
    properties: {
        idp: {
            type: 'array',
            description: 'Idp providers',
            items: {
                $ref: '#/definitions/registration_request_token/properties/403/definitions/Idp',
            },
        },
        version: {
            $ref: '#/definitions/registration_request_token/properties/403/definitions/Version',
        },
    },
    required: ['idp', 'version'],
    title: 'Result',
};
const schema24 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        name: { type: 'string' },
        img: { type: 'string' },
        uuid: { type: 'string' },
        disable_popup_flow: {
            type: 'boolean',
            description: 'If true, the IDP supports a direct redirect flow without popup. The sso_redirect_target is not validated at this point.',
        },
    },
    required: ['name', 'uuid'],
    title: 'Idp',
};
function validate22(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.idp === undefined && (missing0 = 'idp')) ||
                (data.version === undefined && (missing0 = 'version'))) {
                validate22.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            }
            else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'idp' || key0 === 'version')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.idp !== undefined) {
                        let data0 = data.idp;
                        const _errs2 = errors;
                        if (errors === _errs2) {
                            if (Array.isArray(data0)) {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs4 = errors;
                                    const _errs5 = errors;
                                    if (errors === _errs5) {
                                        if (data1 &&
                                            typeof data1 == 'object' &&
                                            !Array.isArray(data1)) {
                                            let missing1;
                                            if ((data1.name === undefined &&
                                                (missing1 = 'name')) ||
                                                (data1.uuid === undefined &&
                                                    (missing1 = 'uuid'))) {
                                                validate22.errors = [
                                                    {
                                                        instancePath: instancePath +
                                                            '/idp/' +
                                                            i0,
                                                        schemaPath: '#/definitions/registration_request_token/properties/403/definitions/Idp/required',
                                                        keyword: 'required',
                                                        params: {
                                                            missingProperty: missing1,
                                                        },
                                                        message: "must have required property '" +
                                                            missing1 +
                                                            "'",
                                                    },
                                                ];
                                                return false;
                                            }
                                            else {
                                                const _errs7 = errors;
                                                for (const key1 in data1) {
                                                    if (!(key1 === 'name' ||
                                                        key1 === 'img' ||
                                                        key1 === 'uuid' ||
                                                        key1 ===
                                                            'disable_popup_flow')) {
                                                        delete data1[key1];
                                                    }
                                                }
                                                if (_errs7 === errors) {
                                                    if (data1.name !== undefined) {
                                                        const _errs8 = errors;
                                                        if (typeof data1.name !==
                                                            'string') {
                                                            validate22.errors =
                                                                [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/idp/' +
                                                                            i0 +
                                                                            '/name',
                                                                        schemaPath: '#/definitions/registration_request_token/properties/403/definitions/Idp/properties/name/type',
                                                                        keyword: 'type',
                                                                        params: {
                                                                            type: 'string',
                                                                        },
                                                                        message: 'must be string',
                                                                    },
                                                                ];
                                                            return false;
                                                        }
                                                        var valid3 = _errs8 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data1.img !==
                                                            undefined) {
                                                            const _errs10 = errors;
                                                            if (typeof data1.img !==
                                                                'string') {
                                                                validate22.errors =
                                                                    [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/idp/' +
                                                                                i0 +
                                                                                '/img',
                                                                            schemaPath: '#/definitions/registration_request_token/properties/403/definitions/Idp/properties/img/type',
                                                                            keyword: 'type',
                                                                            params: {
                                                                                type: 'string',
                                                                            },
                                                                            message: 'must be string',
                                                                        },
                                                                    ];
                                                                return false;
                                                            }
                                                            var valid3 = _errs10 ===
                                                                errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                        if (valid3) {
                                                            if (data1.uuid !==
                                                                undefined) {
                                                                const _errs12 = errors;
                                                                if (typeof data1.uuid !==
                                                                    'string') {
                                                                    validate22.errors =
                                                                        [
                                                                            {
                                                                                instancePath: instancePath +
                                                                                    '/idp/' +
                                                                                    i0 +
                                                                                    '/uuid',
                                                                                schemaPath: '#/definitions/registration_request_token/properties/403/definitions/Idp/properties/uuid/type',
                                                                                keyword: 'type',
                                                                                params: {
                                                                                    type: 'string',
                                                                                },
                                                                                message: 'must be string',
                                                                            },
                                                                        ];
                                                                    return false;
                                                                }
                                                                var valid3 = _errs12 ===
                                                                    errors;
                                                            }
                                                            else {
                                                                var valid3 = true;
                                                            }
                                                            if (valid3) {
                                                                if (data1.disable_popup_flow !==
                                                                    undefined) {
                                                                    const _errs14 = errors;
                                                                    if (typeof data1.disable_popup_flow !==
                                                                        'boolean') {
                                                                        validate22.errors =
                                                                            [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/idp/' +
                                                                                        i0 +
                                                                                        '/disable_popup_flow',
                                                                                    schemaPath: '#/definitions/registration_request_token/properties/403/definitions/Idp/properties/disable_popup_flow/type',
                                                                                    keyword: 'type',
                                                                                    params: {
                                                                                        type: 'boolean',
                                                                                    },
                                                                                    message: 'must be boolean',
                                                                                },
                                                                            ];
                                                                        return false;
                                                                    }
                                                                    var valid3 = _errs14 ===
                                                                        errors;
                                                                }
                                                                else {
                                                                    var valid3 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate22.errors = [
                                                {
                                                    instancePath: instancePath +
                                                        '/idp/' +
                                                        i0,
                                                    schemaPath: '#/definitions/registration_request_token/properties/403/definitions/Idp/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object',
                                                },
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs4 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate22.errors = [
                                    {
                                        instancePath: instancePath + '/idp',
                                        schemaPath: '#/properties/idp/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array',
                                    },
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs2 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.version !== undefined) {
                            let data6 = data.version;
                            const _errs16 = errors;
                            const _errs17 = errors;
                            if (errors === _errs17) {
                                if (data6 &&
                                    typeof data6 == 'object' &&
                                    !Array.isArray(data6)) {
                                    const _errs19 = errors;
                                    for (const key2 in data6) {
                                        if (!(key2 === 'version_id' ||
                                            key2 === 'pseudo_version')) {
                                            delete data6[key2];
                                        }
                                    }
                                    if (_errs19 === errors) {
                                        if (data6.version_id !== undefined) {
                                            const _errs20 = errors;
                                            if (typeof data6.version_id !==
                                                'string') {
                                                validate22.errors = [
                                                    {
                                                        instancePath: instancePath +
                                                            '/version/version_id',
                                                        schemaPath: '#/definitions/registration_request_token/properties/403/definitions/Version/properties/version_id/type',
                                                        keyword: 'type',
                                                        params: {
                                                            type: 'string',
                                                        },
                                                        message: 'must be string',
                                                    },
                                                ];
                                                return false;
                                            }
                                            var valid5 = _errs20 === errors;
                                        }
                                        else {
                                            var valid5 = true;
                                        }
                                        if (valid5) {
                                            if (data6.pseudo_version !==
                                                undefined) {
                                                const _errs22 = errors;
                                                if (typeof data6.pseudo_version !==
                                                    'string') {
                                                    validate22.errors = [
                                                        {
                                                            instancePath: instancePath +
                                                                '/version/pseudo_version',
                                                            schemaPath: '#/definitions/registration_request_token/properties/403/definitions/Version/properties/pseudo_version/type',
                                                            keyword: 'type',
                                                            params: {
                                                                type: 'string',
                                                            },
                                                            message: 'must be string',
                                                        },
                                                    ];
                                                    return false;
                                                }
                                                var valid5 = _errs22 === errors;
                                            }
                                            else {
                                                var valid5 = true;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate22.errors = [
                                        {
                                            instancePath: instancePath + '/version',
                                            schemaPath: '#/definitions/registration_request_token/properties/403/definitions/Version/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object',
                                        },
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs16 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate22.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate22.errors = vErrors;
    return errors === 0;
}
const schema26 = {
    type: 'object',
    description: 'If the conference is PIN-protected, the PIN must be specified in a `pin` HTTP header. If the PIN is required but is incorrect or missing, a `403 Forbidden` error is returned.',
    additionalProperties: false,
    properties: {
        redirect_url: {
            type: 'string',
            description: "`<IdP's SSO URL>?SAMLRequest=<Base64 encoded SAML AuthNRequest message>`",
        },
        redirect_idp: {
            $ref: '#/definitions/registration_request_token/properties/403/definitions/RedirectIdp',
        },
        version: {
            $ref: '#/definitions/registration_request_token/properties/403/definitions/Version',
        },
        disable_popup_flow: {
            type: 'boolean',
            description: 'If true, the IDP supports a direct redirect flow without popup. The sso_redirect_target is validated at this point.',
        },
    },
    required: ['redirect_url', 'redirect_idp', 'version'],
    title: 'ResultRedirect',
};
const schema27 = {
    type: 'object',
    additionalProperties: false,
    properties: { name: { type: 'string' }, uuid: { type: 'string' } },
    required: ['name', 'uuid'],
    title: 'RedirectIdp',
};
function validate24(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.redirect_url === undefined &&
                (missing0 = 'redirect_url')) ||
                (data.redirect_idp === undefined &&
                    (missing0 = 'redirect_idp')) ||
                (data.version === undefined && (missing0 = 'version'))) {
                validate24.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            }
            else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'redirect_url' ||
                        key0 === 'redirect_idp' ||
                        key0 === 'version' ||
                        key0 === 'disable_popup_flow')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.redirect_url !== undefined) {
                        const _errs2 = errors;
                        if (typeof data.redirect_url !== 'string') {
                            validate24.errors = [
                                {
                                    instancePath: instancePath + '/redirect_url',
                                    schemaPath: '#/properties/redirect_url/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.redirect_idp !== undefined) {
                            let data1 = data.redirect_idp;
                            const _errs4 = errors;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (data1 &&
                                    typeof data1 == 'object' &&
                                    !Array.isArray(data1)) {
                                    let missing1;
                                    if ((data1.name === undefined &&
                                        (missing1 = 'name')) ||
                                        (data1.uuid === undefined &&
                                            (missing1 = 'uuid'))) {
                                        validate24.errors = [
                                            {
                                                instancePath: instancePath +
                                                    '/redirect_idp',
                                                schemaPath: '#/definitions/registration_request_token/properties/403/definitions/RedirectIdp/required',
                                                keyword: 'required',
                                                params: {
                                                    missingProperty: missing1,
                                                },
                                                message: "must have required property '" +
                                                    missing1 +
                                                    "'",
                                            },
                                        ];
                                        return false;
                                    }
                                    else {
                                        const _errs7 = errors;
                                        for (const key1 in data1) {
                                            if (!(key1 === 'name' ||
                                                key1 === 'uuid')) {
                                                delete data1[key1];
                                            }
                                        }
                                        if (_errs7 === errors) {
                                            if (data1.name !== undefined) {
                                                const _errs8 = errors;
                                                if (typeof data1.name !==
                                                    'string') {
                                                    validate24.errors = [
                                                        {
                                                            instancePath: instancePath +
                                                                '/redirect_idp/name',
                                                            schemaPath: '#/definitions/registration_request_token/properties/403/definitions/RedirectIdp/properties/name/type',
                                                            keyword: 'type',
                                                            params: {
                                                                type: 'string',
                                                            },
                                                            message: 'must be string',
                                                        },
                                                    ];
                                                    return false;
                                                }
                                                var valid2 = _errs8 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data1.uuid !== undefined) {
                                                    const _errs10 = errors;
                                                    if (typeof data1.uuid !==
                                                        'string') {
                                                        validate24.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/redirect_idp/uuid',
                                                                schemaPath: '#/definitions/registration_request_token/properties/403/definitions/RedirectIdp/properties/uuid/type',
                                                                keyword: 'type',
                                                                params: {
                                                                    type: 'string',
                                                                },
                                                                message: 'must be string',
                                                            },
                                                        ];
                                                        return false;
                                                    }
                                                    var valid2 = _errs10 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate24.errors = [
                                        {
                                            instancePath: instancePath + '/redirect_idp',
                                            schemaPath: '#/definitions/registration_request_token/properties/403/definitions/RedirectIdp/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object',
                                        },
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs4 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.version !== undefined) {
                                let data4 = data.version;
                                const _errs12 = errors;
                                const _errs13 = errors;
                                if (errors === _errs13) {
                                    if (data4 &&
                                        typeof data4 == 'object' &&
                                        !Array.isArray(data4)) {
                                        const _errs15 = errors;
                                        for (const key2 in data4) {
                                            if (!(key2 === 'version_id' ||
                                                key2 === 'pseudo_version')) {
                                                delete data4[key2];
                                            }
                                        }
                                        if (_errs15 === errors) {
                                            if (data4.version_id !== undefined) {
                                                const _errs16 = errors;
                                                if (typeof data4.version_id !==
                                                    'string') {
                                                    validate24.errors = [
                                                        {
                                                            instancePath: instancePath +
                                                                '/version/version_id',
                                                            schemaPath: '#/definitions/registration_request_token/properties/403/definitions/Version/properties/version_id/type',
                                                            keyword: 'type',
                                                            params: {
                                                                type: 'string',
                                                            },
                                                            message: 'must be string',
                                                        },
                                                    ];
                                                    return false;
                                                }
                                                var valid4 = _errs16 === errors;
                                            }
                                            else {
                                                var valid4 = true;
                                            }
                                            if (valid4) {
                                                if (data4.pseudo_version !==
                                                    undefined) {
                                                    const _errs18 = errors;
                                                    if (typeof data4.pseudo_version !==
                                                        'string') {
                                                        validate24.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/version/pseudo_version',
                                                                schemaPath: '#/definitions/registration_request_token/properties/403/definitions/Version/properties/pseudo_version/type',
                                                                keyword: 'type',
                                                                params: {
                                                                    type: 'string',
                                                                },
                                                                message: 'must be string',
                                                            },
                                                        ];
                                                        return false;
                                                    }
                                                    var valid4 = _errs18 === errors;
                                                }
                                                else {
                                                    var valid4 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate24.errors = [
                                            {
                                                instancePath: instancePath + '/version',
                                                schemaPath: '#/definitions/registration_request_token/properties/403/definitions/Version/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object',
                                            },
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs12 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.disable_popup_flow !== undefined) {
                                    const _errs20 = errors;
                                    if (typeof data.disable_popup_flow !==
                                        'boolean') {
                                        validate24.errors = [
                                            {
                                                instancePath: instancePath +
                                                    '/disable_popup_flow',
                                                schemaPath: '#/properties/disable_popup_flow/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean',
                                            },
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs20 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate24.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate24.errors = vErrors;
    return errors === 0;
}
function validate19(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))) {
                validate19.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            }
            else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs2 = errors;
                        if (typeof data0 !== 'string') {
                            validate19.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        if (!(data0 === 'success' ||
                            data0 === 'failed' ||
                            data0 === 'error')) {
                            validate19.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/enum',
                                    keyword: 'enum',
                                    params: {
                                        allowedValues: schema20.properties.status.enum,
                                    },
                                    message: 'must be equal to one of the allowed values',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.result !== undefined) {
                            let data1 = data.result;
                            const _errs4 = errors;
                            const _errs5 = errors;
                            let valid1 = false;
                            let passing0 = null;
                            const _errs6 = errors;
                            if (!validate20(data1, {
                                instancePath: instancePath + '/result',
                                parentData: data,
                                parentDataProperty: 'result',
                                rootData,
                            })) {
                                vErrors =
                                    vErrors === null
                                        ? validate20.errors
                                        : vErrors.concat(validate20.errors);
                                errors = vErrors.length;
                            }
                            var _valid0 = _errs6 === errors;
                            if (_valid0) {
                                valid1 = true;
                                passing0 = 0;
                            }
                            const _errs7 = errors;
                            if (!validate22(data1, {
                                instancePath: instancePath + '/result',
                                parentData: data,
                                parentDataProperty: 'result',
                                rootData,
                            })) {
                                vErrors =
                                    vErrors === null
                                        ? validate22.errors
                                        : vErrors.concat(validate22.errors);
                                errors = vErrors.length;
                            }
                            var _valid0 = _errs7 === errors;
                            if (_valid0 && valid1) {
                                valid1 = false;
                                passing0 = [passing0, 1];
                            }
                            else {
                                if (_valid0) {
                                    valid1 = true;
                                    passing0 = 1;
                                }
                                const _errs8 = errors;
                                if (!validate24(data1, {
                                    instancePath: instancePath + '/result',
                                    parentData: data,
                                    parentDataProperty: 'result',
                                    rootData,
                                })) {
                                    vErrors =
                                        vErrors === null
                                            ? validate24.errors
                                            : vErrors.concat(validate24.errors);
                                    errors = vErrors.length;
                                }
                                var _valid0 = _errs8 === errors;
                                if (_valid0 && valid1) {
                                    valid1 = false;
                                    passing0 = [passing0, 2];
                                }
                                else {
                                    if (_valid0) {
                                        valid1 = true;
                                        passing0 = 2;
                                    }
                                    const _errs9 = errors;
                                    if (typeof data1 !== 'string') {
                                        const err0 = {
                                            instancePath: instancePath + '/result',
                                            schemaPath: '#/definitions/registration_request_token/properties/415/definitions/415/properties/result/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err0];
                                        }
                                        else {
                                            vErrors.push(err0);
                                        }
                                        errors++;
                                    }
                                    var _valid0 = _errs9 === errors;
                                    if (_valid0 && valid1) {
                                        valid1 = false;
                                        passing0 = [passing0, 3];
                                    }
                                    else {
                                        if (_valid0) {
                                            valid1 = true;
                                            passing0 = 3;
                                        }
                                    }
                                }
                            }
                            if (!valid1) {
                                const err1 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath: '#/properties/result/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing0 },
                                    message: 'must match exactly one schema in oneOf',
                                };
                                if (vErrors === null) {
                                    vErrors = [err1];
                                }
                                else {
                                    vErrors.push(err1);
                                }
                                errors++;
                                validate19.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs5;
                                if (vErrors !== null) {
                                    if (_errs5) {
                                        vErrors.length = _errs5;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid0 = _errs4 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate19.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate19.errors = vErrors;
    return errors === 0;
}
function validate18(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (!validate19(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
    })) {
        vErrors =
            vErrors === null
                ? validate19.errors
                : vErrors.concat(validate19.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
        validate18.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate18.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationRequestToken404 = validate27;
const schema30 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '404': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. success.',
                    enum: ['failed'],
                },
                result: { type: 'string', description: 'Error string' },
            },
            required: ['status', 'result'],
            title: 'Status404',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/registration_request_token/properties/404/definitions/404',
        },
    ],
};
const schema31 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. success.',
            enum: ['failed'],
        },
        result: { type: 'string', description: 'Error string' },
    },
    required: ['status', 'result'],
    title: 'Status404',
};
function validate27(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))) {
                const err0 = {
                    instancePath,
                    schemaPath: '#/definitions/registration_request_token/properties/404/definitions/404/required',
                    keyword: 'required',
                    params: { missingProperty: missing0 },
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
            else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/definitions/registration_request_token/properties/404/definitions/404/properties/status/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            }
                            else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'failed')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/definitions/registration_request_token/properties/404/definitions/404/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues: schema31.properties.status.enum,
                                },
                                message: 'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            }
                            else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'string') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath: '#/definitions/registration_request_token/properties/404/definitions/404/properties/result/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                }
                                else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                    }
                }
            }
        }
        else {
            const err4 = {
                instancePath,
                schemaPath: '#/definitions/registration_request_token/properties/404/definitions/404/type',
                keyword: 'type',
                params: { type: 'object' },
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        }
        else {
            vErrors.push(err5);
        }
        errors++;
        validate27.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate27.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationRequestToken415 = validate28;
const schema32 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '415': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. failed.',
                    enum: ['failed'],
                },
                result: { type: 'string', description: 'Error strings' },
            },
            required: ['status', 'result'],
            title: 'Status415',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/registration_request_token/properties/415/definitions/415',
        },
    ],
};
const schema33 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. failed.',
            enum: ['failed'],
        },
        result: { type: 'string', description: 'Error strings' },
    },
    required: ['status', 'result'],
    title: 'Status415',
};
function validate28(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))) {
                const err0 = {
                    instancePath,
                    schemaPath: '#/definitions/registration_request_token/properties/415/definitions/415/required',
                    keyword: 'required',
                    params: { missingProperty: missing0 },
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
            else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/definitions/registration_request_token/properties/415/definitions/415/properties/status/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            }
                            else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'failed')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/definitions/registration_request_token/properties/415/definitions/415/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues: schema33.properties.status.enum,
                                },
                                message: 'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            }
                            else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'string') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath: '#/definitions/registration_request_token/properties/415/definitions/415/properties/result/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                }
                                else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                    }
                }
            }
        }
        else {
            const err4 = {
                instancePath,
                schemaPath: '#/definitions/registration_request_token/properties/415/definitions/415/type',
                keyword: 'type',
                params: { type: 'object' },
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        }
        else {
            vErrors.push(err5);
        }
        errors++;
        validate28.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate28.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationRequestToken502 = validate29;
const schema34 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '5xx': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. failed.',
                    enum: ['failed'],
                },
                result: {
                    $ref: '#/definitions/registration_request_token/properties/415/definitions/415/properties/result',
                },
            },
            required: ['status', 'result'],
            title: 'Status5xx',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/registration_request_token/properties/502/definitions/5xx',
        },
    ],
};
const schema35 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. failed.',
            enum: ['failed'],
        },
        result: {
            $ref: '#/definitions/registration_request_token/properties/415/definitions/415/properties/result',
        },
    },
    required: ['status', 'result'],
    title: 'Status5xx',
};
function validate30(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))) {
                validate30.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            }
            else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs2 = errors;
                        if (typeof data0 !== 'string') {
                            validate30.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        if (!(data0 === 'failed')) {
                            validate30.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/enum',
                                    keyword: 'enum',
                                    params: {
                                        allowedValues: schema35.properties.status.enum,
                                    },
                                    message: 'must be equal to one of the allowed values',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.result !== undefined) {
                            const _errs4 = errors;
                            if (typeof data.result !== 'string') {
                                validate30.errors = [
                                    {
                                        instancePath: instancePath + '/result',
                                        schemaPath: '#/definitions/registration_request_token/properties/415/definitions/415/properties/result/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                    },
                                ];
                                return false;
                            }
                            var valid0 = _errs4 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate30.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate30.errors = vErrors;
    return errors === 0;
}
function validate29(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (!validate30(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
    })) {
        vErrors =
            vErrors === null
                ? validate30.errors
                : vErrors.concat(validate30.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
        validate29.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate29.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationRequestToken503 = validate32;
function validate32(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (!validate30(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
    })) {
        vErrors =
            vErrors === null
                ? validate30.errors
                : vErrors.concat(validate30.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
        validate32.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate32.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationRequestToken504 = validate34;
function validate34(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (!validate30(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
    })) {
        vErrors =
            vErrors === null
                ? validate30.errors
                : vErrors.concat(validate30.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
        validate34.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate34.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationRequestToken529 = validate36;
function validate36(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (!validate30(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
    })) {
        vErrors =
            vErrors === null
                ? validate30.errors
                : vErrors.concat(validate30.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
        validate36.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate36.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationExchangeToken200 = validate38;
function validate38(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (!validate13(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
    })) {
        vErrors =
            vErrors === null
                ? validate13.errors
                : vErrors.concat(validate13.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
        validate38.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate38.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationExchangeToken403 = validate40;
function validate40(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (!validate19(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
    })) {
        vErrors =
            vErrors === null
                ? validate19.errors
                : vErrors.concat(validate19.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
        validate40.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate40.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationExchangeToken404 = validate42;
function validate42(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))) {
                const err0 = {
                    instancePath,
                    schemaPath: '#/definitions/registration_request_token/properties/404/definitions/404/required',
                    keyword: 'required',
                    params: { missingProperty: missing0 },
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
            else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/definitions/registration_request_token/properties/404/definitions/404/properties/status/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            }
                            else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'failed')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/definitions/registration_request_token/properties/404/definitions/404/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues: schema31.properties.status.enum,
                                },
                                message: 'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            }
                            else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'string') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath: '#/definitions/registration_request_token/properties/404/definitions/404/properties/result/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                }
                                else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                    }
                }
            }
        }
        else {
            const err4 = {
                instancePath,
                schemaPath: '#/definitions/registration_request_token/properties/404/definitions/404/type',
                keyword: 'type',
                params: { type: 'object' },
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        }
        else {
            vErrors.push(err5);
        }
        errors++;
        validate42.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate42.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationExchangeToken415 = validate43;
function validate43(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))) {
                const err0 = {
                    instancePath,
                    schemaPath: '#/definitions/registration_request_token/properties/415/definitions/415/required',
                    keyword: 'required',
                    params: { missingProperty: missing0 },
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
            else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/definitions/registration_request_token/properties/415/definitions/415/properties/status/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            }
                            else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'failed')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/definitions/registration_request_token/properties/415/definitions/415/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues: schema33.properties.status.enum,
                                },
                                message: 'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            }
                            else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'string') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath: '#/definitions/registration_request_token/properties/415/definitions/415/properties/result/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                }
                                else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                    }
                }
            }
        }
        else {
            const err4 = {
                instancePath,
                schemaPath: '#/definitions/registration_request_token/properties/415/definitions/415/type',
                keyword: 'type',
                params: { type: 'object' },
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        }
        else {
            vErrors.push(err5);
        }
        errors++;
        validate43.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate43.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationExchangeToken502 = validate44;
function validate44(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (!validate30(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
    })) {
        vErrors =
            vErrors === null
                ? validate30.errors
                : vErrors.concat(validate30.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
        validate44.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate44.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationExchangeToken503 = validate46;
function validate46(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (!validate30(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
    })) {
        vErrors =
            vErrors === null
                ? validate30.errors
                : vErrors.concat(validate30.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
        validate46.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate46.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationExchangeToken504 = validate48;
function validate48(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (!validate30(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
    })) {
        vErrors =
            vErrors === null
                ? validate30.errors
                : vErrors.concat(validate30.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
        validate48.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate48.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationExchangeToken529 = validate50;
function validate50(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (!validate30(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
    })) {
        vErrors =
            vErrors === null
                ? validate30.errors
                : vErrors.concat(validate30.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
        validate50.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate50.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationRefreshToken200 = validate52;
const schema50 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '200': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. success.',
                    enum: ['success'],
                },
                result: {
                    $ref: '#/definitions/registration_refresh_token/properties/200/definitions/Result',
                },
            },
            required: ['status', 'result'],
            title: 'Status200',
        },
        Result: {
            type: 'object',
            additionalProperties: false,
            properties: {
                token: {
                    type: 'string',
                    description: 'The new authentication token for future requests.',
                },
                role: {
                    type: 'string',
                    enum: ['HOST', 'GUEST'],
                    description: 'Whether the participant is connecting as a `HOST` or a `GUEST`.',
                },
                expires: {
                    type: 'string',
                    description: 'Validity lifetime in seconds.',
                },
                client_stats_update_interval: {
                    type: 'number',
                    description: 'Signals the statistics update interval',
                },
            },
            required: ['token', 'expires'],
            title: 'Result',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/registration_refresh_token/properties/200/definitions/200',
        },
    ],
};
const schema51 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. success.',
            enum: ['success'],
        },
        result: {
            $ref: '#/definitions/registration_refresh_token/properties/200/definitions/Result',
        },
    },
    required: ['status', 'result'],
    title: 'Status200',
};
const schema52 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        token: {
            type: 'string',
            description: 'The new authentication token for future requests.',
        },
        role: {
            type: 'string',
            enum: ['HOST', 'GUEST'],
            description: 'Whether the participant is connecting as a `HOST` or a `GUEST`.',
        },
        expires: { type: 'string', description: 'Validity lifetime in seconds.' },
        client_stats_update_interval: {
            type: 'number',
            description: 'Signals the statistics update interval',
        },
    },
    required: ['token', 'expires'],
    title: 'Result',
};
function validate53(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))) {
                validate53.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            }
            else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs2 = errors;
                        if (typeof data0 !== 'string') {
                            validate53.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        if (!(data0 === 'success')) {
                            validate53.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/enum',
                                    keyword: 'enum',
                                    params: {
                                        allowedValues: schema51.properties.status.enum,
                                    },
                                    message: 'must be equal to one of the allowed values',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.result !== undefined) {
                            let data1 = data.result;
                            const _errs4 = errors;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (data1 &&
                                    typeof data1 == 'object' &&
                                    !Array.isArray(data1)) {
                                    let missing1;
                                    if ((data1.token === undefined &&
                                        (missing1 = 'token')) ||
                                        (data1.expires === undefined &&
                                            (missing1 = 'expires'))) {
                                        validate53.errors = [
                                            {
                                                instancePath: instancePath + '/result',
                                                schemaPath: '#/definitions/registration_refresh_token/properties/200/definitions/Result/required',
                                                keyword: 'required',
                                                params: {
                                                    missingProperty: missing1,
                                                },
                                                message: "must have required property '" +
                                                    missing1 +
                                                    "'",
                                            },
                                        ];
                                        return false;
                                    }
                                    else {
                                        const _errs7 = errors;
                                        for (const key1 in data1) {
                                            if (!(key1 === 'token' ||
                                                key1 === 'role' ||
                                                key1 === 'expires' ||
                                                key1 ===
                                                    'client_stats_update_interval')) {
                                                delete data1[key1];
                                            }
                                        }
                                        if (_errs7 === errors) {
                                            if (data1.token !== undefined) {
                                                const _errs8 = errors;
                                                if (typeof data1.token !==
                                                    'string') {
                                                    validate53.errors = [
                                                        {
                                                            instancePath: instancePath +
                                                                '/result/token',
                                                            schemaPath: '#/definitions/registration_refresh_token/properties/200/definitions/Result/properties/token/type',
                                                            keyword: 'type',
                                                            params: {
                                                                type: 'string',
                                                            },
                                                            message: 'must be string',
                                                        },
                                                    ];
                                                    return false;
                                                }
                                                var valid2 = _errs8 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data1.role !== undefined) {
                                                    let data3 = data1.role;
                                                    const _errs10 = errors;
                                                    if (typeof data3 !==
                                                        'string') {
                                                        validate53.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/result/role',
                                                                schemaPath: '#/definitions/registration_refresh_token/properties/200/definitions/Result/properties/role/type',
                                                                keyword: 'type',
                                                                params: {
                                                                    type: 'string',
                                                                },
                                                                message: 'must be string',
                                                            },
                                                        ];
                                                        return false;
                                                    }
                                                    if (!(data3 === 'HOST' ||
                                                        data3 === 'GUEST')) {
                                                        validate53.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/result/role',
                                                                schemaPath: '#/definitions/registration_refresh_token/properties/200/definitions/Result/properties/role/enum',
                                                                keyword: 'enum',
                                                                params: {
                                                                    allowedValues: schema52
                                                                        .properties
                                                                        .role
                                                                        .enum,
                                                                },
                                                                message: 'must be equal to one of the allowed values',
                                                            },
                                                        ];
                                                        return false;
                                                    }
                                                    var valid2 = _errs10 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                                if (valid2) {
                                                    if (data1.expires !==
                                                        undefined) {
                                                        const _errs12 = errors;
                                                        if (typeof data1.expires !==
                                                            'string') {
                                                            validate53.errors =
                                                                [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/result/expires',
                                                                        schemaPath: '#/definitions/registration_refresh_token/properties/200/definitions/Result/properties/expires/type',
                                                                        keyword: 'type',
                                                                        params: {
                                                                            type: 'string',
                                                                        },
                                                                        message: 'must be string',
                                                                    },
                                                                ];
                                                            return false;
                                                        }
                                                        var valid2 = _errs12 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                        if (data1.client_stats_update_interval !==
                                                            undefined) {
                                                            const _errs14 = errors;
                                                            if (!(typeof data1.client_stats_update_interval ==
                                                                'number')) {
                                                                validate53.errors =
                                                                    [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/result/client_stats_update_interval',
                                                                            schemaPath: '#/definitions/registration_refresh_token/properties/200/definitions/Result/properties/client_stats_update_interval/type',
                                                                            keyword: 'type',
                                                                            params: {
                                                                                type: 'number',
                                                                            },
                                                                            message: 'must be number',
                                                                        },
                                                                    ];
                                                                return false;
                                                            }
                                                            var valid2 = _errs14 ===
                                                                errors;
                                                        }
                                                        else {
                                                            var valid2 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate53.errors = [
                                        {
                                            instancePath: instancePath + '/result',
                                            schemaPath: '#/definitions/registration_refresh_token/properties/200/definitions/Result/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object',
                                        },
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs4 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate53.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate53.errors = vErrors;
    return errors === 0;
}
function validate52(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (!validate53(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
    })) {
        vErrors =
            vErrors === null
                ? validate53.errors
                : vErrors.concat(validate53.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
        validate52.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate52.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationRefreshToken403 = validate55;
const schema53 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '403': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. success.',
                    enum: ['success', 'failed'],
                },
                result: {
                    $ref: '#/definitions/registration_request_token/properties/415/definitions/415/properties/result',
                },
            },
            required: ['status', 'result'],
            title: 'Status403',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/registration_refresh_token/properties/403/definitions/403',
        },
    ],
};
const schema54 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. success.',
            enum: ['success', 'failed'],
        },
        result: {
            $ref: '#/definitions/registration_request_token/properties/415/definitions/415/properties/result',
        },
    },
    required: ['status', 'result'],
    title: 'Status403',
};
function validate56(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))) {
                validate56.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            }
            else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs2 = errors;
                        if (typeof data0 !== 'string') {
                            validate56.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        if (!(data0 === 'success' || data0 === 'failed')) {
                            validate56.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/enum',
                                    keyword: 'enum',
                                    params: {
                                        allowedValues: schema54.properties.status.enum,
                                    },
                                    message: 'must be equal to one of the allowed values',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.result !== undefined) {
                            const _errs4 = errors;
                            if (typeof data.result !== 'string') {
                                validate56.errors = [
                                    {
                                        instancePath: instancePath + '/result',
                                        schemaPath: '#/definitions/registration_request_token/properties/415/definitions/415/properties/result/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                    },
                                ];
                                return false;
                            }
                            var valid0 = _errs4 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate56.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate56.errors = vErrors;
    return errors === 0;
}
function validate55(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (!validate56(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
    })) {
        vErrors =
            vErrors === null
                ? validate56.errors
                : vErrors.concat(validate56.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
        validate55.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate55.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationReleaseTokenBody = validate58;
const schema56 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        TopLevel: {
            type: 'object',
            additionalProperties: false,
            properties: { reason: { type: 'string' } },
            title: 'TopLevel',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/registration_release_token/properties/Body/definitions/TopLevel',
        },
    ],
};
const schema57 = {
    type: 'object',
    additionalProperties: false,
    properties: { reason: { type: 'string' } },
    title: 'TopLevel',
};
function validate58(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            const _errs4 = errors;
            for (const key0 in data) {
                if (!(key0 === 'reason')) {
                    delete data[key0];
                }
            }
            if (_errs4 === errors) {
                if (data.reason !== undefined) {
                    if (typeof data.reason !== 'string') {
                        const err0 = {
                            instancePath: instancePath + '/reason',
                            schemaPath: '#/definitions/registration_release_token/properties/Body/definitions/TopLevel/properties/reason/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                        };
                        if (vErrors === null) {
                            vErrors = [err0];
                        }
                        else {
                            vErrors.push(err0);
                        }
                        errors++;
                    }
                }
            }
        }
        else {
            const err1 = {
                instancePath,
                schemaPath: '#/definitions/registration_release_token/properties/Body/definitions/TopLevel/type',
                keyword: 'type',
                params: { type: 'object' },
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err2 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
        validate58.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate58.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationReleaseToken200 = validate59;
const schema58 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '200': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. success.',
                    enum: ['success'],
                },
                result: {
                    type: 'boolean',
                    description: 'The result is true if successful, false otherwise.',
                },
            },
            required: ['status', 'result'],
            title: 'Status200',
        },
    },
    oneOf: [
        {
            $ref: '#/definitions/registration_release_token/properties/200/definitions/200',
        },
    ],
};
const schema59 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. success.',
            enum: ['success'],
        },
        result: {
            type: 'boolean',
            description: 'The result is true if successful, false otherwise.',
        },
    },
    required: ['status', 'result'],
    title: 'Status200',
};
function validate59(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    const _errs2 = errors;
    if (errors === _errs2) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))) {
                const err0 = {
                    instancePath,
                    schemaPath: '#/definitions/registration_release_token/properties/200/definitions/200/required',
                    keyword: 'required',
                    params: { missingProperty: missing0 },
                    message: "must have required property '" + missing0 + "'",
                };
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
            else {
                const _errs4 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs4 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs5 = errors;
                        if (typeof data0 !== 'string') {
                            const err1 = {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/definitions/registration_release_token/properties/200/definitions/200/properties/status/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            }
                            else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        if (!(data0 === 'success')) {
                            const err2 = {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/definitions/registration_release_token/properties/200/definitions/200/properties/status/enum',
                                keyword: 'enum',
                                params: {
                                    allowedValues: schema59.properties.status.enum,
                                },
                                message: 'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            }
                            else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                        var valid2 = _errs5 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.result !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.result !== 'boolean') {
                                const err3 = {
                                    instancePath: instancePath + '/result',
                                    schemaPath: '#/definitions/registration_release_token/properties/200/definitions/200/properties/result/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                }
                                else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            var valid2 = _errs7 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                    }
                }
            }
        }
        else {
            const err4 = {
                instancePath,
                schemaPath: '#/definitions/registration_release_token/properties/200/definitions/200/type',
                keyword: 'type',
                params: { type: 'object' },
                message: 'must be object',
            };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err5];
        }
        else {
            vErrors.push(err5);
        }
        errors++;
        validate59.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate59.errors = vErrors;
    return errors === 0;
}
export const validateRegistrationReleaseToken403 = validate60;
function validate60(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (!validate56(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
    })) {
        vErrors =
            vErrors === null
                ? validate56.errors
                : vErrors.concat(validate56.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
        validate60.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate60.errors = vErrors;
    return errors === 0;
}
export const validateRegistrations200 = validate62;
const schema61 = {
    $schema: 'http://json-schema.org/draft-06/schema#',
    definitions: {
        '200': {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    type: 'string',
                    description: 'Status of the response, eg. success.',
                    enum: ['success'],
                },
                result: {
                    $ref: '#/definitions/registrations/properties/200/definitions/Result',
                },
            },
            required: ['status', 'result'],
            title: 'Status200',
        },
        Result: {
            type: 'array',
            items: {
                $ref: '#/definitions/registrations/properties/200/definitions/Registration',
            },
            title: 'Result',
        },
        Registration: {
            type: 'object',
            additionalProperties: false,
            properties: {
                alias: { type: 'string' },
                username: { type: 'string' },
                description: { type: 'string' },
            },
            required: ['alias'],
            title: 'Registration',
        },
    },
    oneOf: [
        { $ref: '#/definitions/registrations/properties/200/definitions/200' },
    ],
};
const schema62 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        status: {
            type: 'string',
            description: 'Status of the response, eg. success.',
            enum: ['success'],
        },
        result: {
            $ref: '#/definitions/registrations/properties/200/definitions/Result',
        },
    },
    required: ['status', 'result'],
    title: 'Status200',
};
const schema63 = {
    type: 'array',
    items: {
        $ref: '#/definitions/registrations/properties/200/definitions/Registration',
    },
    title: 'Result',
};
const schema64 = {
    type: 'object',
    additionalProperties: false,
    properties: {
        alias: { type: 'string' },
        username: { type: 'string' },
        description: { type: 'string' },
    },
    required: ['alias'],
    title: 'Registration',
};
function validate64(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (Array.isArray(data)) {
            var valid0 = true;
            const len0 = data.length;
            for (let i0 = 0; i0 < len0; i0++) {
                let data0 = data[i0];
                const _errs1 = errors;
                const _errs2 = errors;
                if (errors === _errs2) {
                    if (data0 &&
                        typeof data0 == 'object' &&
                        !Array.isArray(data0)) {
                        let missing0;
                        if (data0.alias === undefined && (missing0 = 'alias')) {
                            validate64.errors = [
                                {
                                    instancePath: instancePath + '/' + i0,
                                    schemaPath: '#/definitions/registrations/properties/200/definitions/Registration/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing0 },
                                    message: "must have required property '" +
                                        missing0 +
                                        "'",
                                },
                            ];
                            return false;
                        }
                        else {
                            const _errs4 = errors;
                            for (const key0 in data0) {
                                if (!(key0 === 'alias' ||
                                    key0 === 'username' ||
                                    key0 === 'description')) {
                                    delete data0[key0];
                                }
                            }
                            if (_errs4 === errors) {
                                if (data0.alias !== undefined) {
                                    const _errs5 = errors;
                                    if (typeof data0.alias !== 'string') {
                                        validate64.errors = [
                                            {
                                                instancePath: instancePath +
                                                    '/' +
                                                    i0 +
                                                    '/alias',
                                                schemaPath: '#/definitions/registrations/properties/200/definitions/Registration/properties/alias/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                            },
                                        ];
                                        return false;
                                    }
                                    var valid2 = _errs5 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.username !== undefined) {
                                        const _errs7 = errors;
                                        if (typeof data0.username !== 'string') {
                                            validate64.errors = [
                                                {
                                                    instancePath: instancePath +
                                                        '/' +
                                                        i0 +
                                                        '/username',
                                                    schemaPath: '#/definitions/registrations/properties/200/definitions/Registration/properties/username/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                },
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs7 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data0.description !== undefined) {
                                            const _errs9 = errors;
                                            if (typeof data0.description !==
                                                'string') {
                                                validate64.errors = [
                                                    {
                                                        instancePath: instancePath +
                                                            '/' +
                                                            i0 +
                                                            '/description',
                                                        schemaPath: '#/definitions/registrations/properties/200/definitions/Registration/properties/description/type',
                                                        keyword: 'type',
                                                        params: {
                                                            type: 'string',
                                                        },
                                                        message: 'must be string',
                                                    },
                                                ];
                                                return false;
                                            }
                                            var valid2 = _errs9 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else {
                        validate64.errors = [
                            {
                                instancePath: instancePath + '/' + i0,
                                schemaPath: '#/definitions/registrations/properties/200/definitions/Registration/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object',
                            },
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
                if (!valid0) {
                    break;
                }
            }
        }
        else {
            validate64.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                },
            ];
            return false;
        }
    }
    validate64.errors = vErrors;
    return errors === 0;
}
function validate63(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.status === undefined && (missing0 = 'status')) ||
                (data.result === undefined && (missing0 = 'result'))) {
                validate63.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'",
                    },
                ];
                return false;
            }
            else {
                const _errs1 = errors;
                for (const key0 in data) {
                    if (!(key0 === 'status' || key0 === 'result')) {
                        delete data[key0];
                    }
                }
                if (_errs1 === errors) {
                    if (data.status !== undefined) {
                        let data0 = data.status;
                        const _errs2 = errors;
                        if (typeof data0 !== 'string') {
                            validate63.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                },
                            ];
                            return false;
                        }
                        if (!(data0 === 'success')) {
                            validate63.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/enum',
                                    keyword: 'enum',
                                    params: {
                                        allowedValues: schema62.properties.status.enum,
                                    },
                                    message: 'must be equal to one of the allowed values',
                                },
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.result !== undefined) {
                            const _errs4 = errors;
                            if (!validate64(data.result, {
                                instancePath: instancePath + '/result',
                                parentData: data,
                                parentDataProperty: 'result',
                                rootData,
                            })) {
                                vErrors =
                                    vErrors === null
                                        ? validate64.errors
                                        : vErrors.concat(validate64.errors);
                                errors = vErrors.length;
                            }
                            var valid0 = _errs4 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate63.errors = [
                {
                    instancePath,
                    schemaPath: '#/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                },
            ];
            return false;
        }
    }
    validate63.errors = vErrors;
    return errors === 0;
}
function validate62(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (!validate63(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
    })) {
        vErrors =
            vErrors === null
                ? validate63.errors
                : vErrors.concat(validate63.errors);
        errors = vErrors.length;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    if (!valid0) {
        const err0 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
        };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
        validate62.errors = vErrors;
        return false;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate62.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validation.js.map